<template>
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <h2>앱 설치 안내</h2>
      <!--p>{{ ua }}</p-->
      <!-- 1. 웹뷰 환경 -->
      <div v-if="isWebView">
        <p v-if="isIos">
          카카오톡 등 SNS 앱 내 브라우저는 설치를 지원하지 않습니다.&nbsp;
          브라우저 화면 하단의
          <strong>공유 아이콘</strong>
          <img
            :src="share"
            alt="공유"
            style="width: 20px; height: 20px; vertical-align: middle"
          />
          을 누른 뒤
          <strong>"Safari로 열기"</strong>
          를 클릭하셔서 공식 브라우저로 접속하시면 앱을 홈 화면에 추가하실 수
          있습니다.
        </p>
        <p v-else-if="isKakao">
          카카오톡 앱 내 브라우저는 설치를 지원하지 않습니다.&nbsp; 브라우저
          화면 하단의 메뉴(
          <img
            :src="menu"
            alt="메뉴"
            style="width: 20px; height: 20px; vertical-align: middle"
          />
          )를 누른 뒤
          <strong>"다른 브라우저로 열기"</strong>
          를 클릭하셔서 공식 브라우저로 접속하시면 앱을 홈 화면에 추가하실 수
          있습니다.
          <br />
          <!--공식 브라우저에서는 <strong>앱 설치 팝업</strong>이 뜨거나 브라우저 화면 상단 우측에 
          <strong>설치 아이콘 <img :src="install"  alt="설치" style="width: 20px; height: 20px; vertical-align: middle;"/></strong>이 생깁니다.
          두 방법 중 한 가지를 이용해서 설치하실 수 있습니다.-->
        </p>
        <p v-else>
          SNS 앱 내 브라우저는 설치를 지원하지 않습니다.&nbsp; 브라우저 화면
          하단 또는 상단의 메뉴(
          <img
            :src="menu"
            alt="메뉴"
            style="width: 20px; height: 20px; vertical-align: middle"
          />
          )를 누른 뒤
          <strong>"다른 앱으로 열기"</strong>
          를 클릭하셔서 공식 브라우저로 접속하시면 앱을 홈 화면에 추가하실 수
          있습니다.
          <br />
          <!--공식 브라우저에서는 <strong>앱 설치 팝업</strong>이 뜨거나 브라우저 화면 상단 우측에 
          <strong>설치 아이콘 <img :src="install"  alt="설치" style="width: 20px; height: 20px; vertical-align: middle;"/></strong>이 생깁니다.
          두 방법 중 한 가지를 이용해서 설치하실 수 있습니다.-->
        </p>
      </div>
      <!-- 2. 브라우저 환경 -->
      <div v-else>
        <!-- 1) PWA 지원 브라우저 (최우선) -->
        <p v-if="deferredPromptAvailable">
          앱을 설치하여 더 편리하게 이용해 보세요!
        </p>

        <!-- 2) iOS Safari -->
        <p v-else-if="isIos">
          Safari 브라우저 화면 하단의
          <strong>
            공유 아이콘(
            <img
              :src="share"
              alt="공유"
              style="width: 20px; height: 20px; vertical-align: middle"
            />
            )
          </strong>
          을 누른 뒤 메뉴에서
          <strong>"홈 화면에 추가"</strong>
          를 선택해 설치하시면 편리하게 이용하실 수 있습니다.
        </p>

        <!-- 3) PWA를 자동 인식하는 최신 브라우저거나 PWA를 지원하지 않는 브라우저 -->
        <div v-else>
          <p v-if="isMobile">
            브라우저 상단 우측
            <strong>
              설치 아이콘
              <img
                :src="install"
                alt="설치"
                style="width: 20px; height: 20px; vertical-align: middle"
              />
            </strong>
            을 클릭하여 설치하실 수 있습니다.
          </p>
          <p v-else>
            브라우저 상단 주소창 우측의
            <strong>앱에서 열기</strong>
            또는 브라우저별
            <strong>설치 아이콘</strong>
            을 클릭하여 설치하실 수 있습니다.
          </p>
          아이콘이 보이지 않는 경우 브라우저의 메뉴 버튼을 눌러
          <strong>"홈 화면에 추가"</strong>
          또는
          <strong>"현재 페이지 추가 > 홈화면"</strong>
          을 선택해 설치하시면 편리하게 이용하실 수 있습니다. (메뉴 아이콘은
          보통
          <img
            :src="menu"
            alt="메뉴"
            style="width: 20x; height: 20px; vertical-align: middle"
          />
          또는
          <strong>☰</strong>
          형태로, 오른쪽 상단 또는 하단에 있습니다.)
        </div>
      </div>
      <div class="modal-actions">
        <button
          v-if="!isIos && !isWebView && deferredPromptAvailable"
          @click="installPWA"
        >
          설치하기
        </button>
        <button @click="closeModalAndRememberLater">
          {{
            isIos || isWebView || !deferredPromptAvailable ? '확인' : '나중에요'
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  // 전역에서 deferredPrompt를 가져오기
  import { getDeferredPrompt } from '@/main.js'
  import share from '@/assets/share.png'
  import install from '@/assets/install.png'
  import menu from '@/assets/menu.png'
  import { useApolloClient } from '@vue/apollo-composable'

  export default {
    props: {
      showModal: {
        type: Boolean,
        default: false,
      },
      deferredPromptAvailable: {
        type: Boolean,
        default: false,
      },
      isIos: {
        type: Boolean,
        default: false,
      },
      isKakao: {
        type: Boolean,
        default: false,
      },
      isWebView: {
        type: Boolean,
        default: false,
      },
      isMobile: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:showModal'],
    data() {
      return {
        sessionStorageKey: 'pwaInstallModalLater',
        share,
        install,
        menu,
      }
    },
    mounted() {
      window.addEventListener('appinstalled', () => {
        sessionStorage.removeItem(this.sessionStorageKey)
        this.closeModal()
      })
    },
    methods: {
      installPWA() {
        const deferredPrompt = getDeferredPrompt()
        if (deferredPrompt) {
          deferredPrompt.prompt()
          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              localStorage.setItem('pwaInstalled', 'true')
            }
            window.deferredPwaPrompt = null
            this.closeModal()
          })
        } else {
          this.closeModal()
        }
      },
      closeModal() {
        this.$emit('update:showModal', false)
      },
      closeModalAndRememberLater() {
        sessionStorage.setItem(this.sessionStorageKey, 'true')
        this.closeModal()
      },
      copyToClipboard(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            alert('복사되었습니다!')
          })
          .catch((err) => {
            alert('복사에 실패했습니다.')
            console.error(err)
          })
      },
    },
  }
</script>

<style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    padding: 1rem;
    border-radius: 12px;
    text-align: center;
    width: 90%;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.2);
  }

  .modal-content h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: var(--font-size-12);
    color: #333;
  }
  .modal-content p {
    margin-bottom: 1rem;
    font-size: var(--font-size-10);
    color: #555;
  }

  .modal-actions button {
    margin: 10px;
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .modal-actions button:first-child {
    background-color: #4caf50;
    color: white;
  }

  .modal-actions button:last-child {
    background-color: #f44336;
    color: white;
  }
</style>
